import { useAppSelector, useTheme, IconButton, Icon } from '../../base';
import { loginActions, loginSelectors } from '../../actions';
import {
    ForgotPasswordForm,
    LoginCardLayout,
    MobileLoginLayout,
    PasswordEmailSent,
} from '../../components';
import { useEffect } from 'react';
import { useMediaQuery as useMuiMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../routes/RoutePaths';

const ForgotPasswordPage = () => {
    const isResetPasswordEmailSent = useAppSelector(
        loginSelectors.getIsResetPasswordEmailSent
    );
    const theme = useTheme();
    const isMobile = useMuiMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            loginActions.setResetPasswordEmailSent({
                resetPasswordEmailSent: false,
            });
        };
    }, []);

    const LayoutComponent = isMobile ? MobileLoginLayout : LoginCardLayout;

    return (
        <LayoutComponent>
            {isMobile && (
                <IconButton
                    onClick={() => navigate(RoutePaths.login)}
                    sx={{
                        position: 'absolute',
                        top: theme.spacing(2),
                        insetInlineStart: theme.spacing(2),
                        zIndex: 10,
                        color: 'white', // Icon color
                        backgroundColor: theme.palette.secondary.main, // Button background
                        '&:hover': {
                            // Optional: Adjust hover background
                            backgroundColor: theme.palette.secondary.dark,
                        },
                    }}
                >
                    <Icon name="BackIcon" />
                </IconButton>
            )}
            {isResetPasswordEmailSent ? (
                <PasswordEmailSent isMobile={isMobile} />
            ) : (
                <ForgotPasswordForm isMobile={isMobile} />
            )}
        </LayoutComponent>
    );
};

export default ForgotPasswordPage;
